import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Voy a pasar hambre?',
    a: 'No, el protocolo incluye proteínas y grasas saludables para mantenerte satisfecha mientras te desinflamas.'
  }, {
    q: '¿Tengo que comprar suplementos caros?',
    a: 'No, todo lo que necesitas está en tu supermercado local.'
  }, {
    q: '¿Es seguro si trabajo todo el día?',
    a: 'Totalmente, está diseñado para mujeres activas con horarios reales.'
  }, {
    q: '¿Puedo tomar café?',
    a: 'Sí, te enseñamos cómo tomarlo sin que afecte tus niveles de cortisol.'
  }, {
    q: '¿Es un pago único?',
    a: 'Sí, un solo pago y tienes acceso al protocolo de por vida.'
  }];
  return <Section className="bg-cream" data-id="element-13">
      <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-10 text-center" data-id="element-14">
        Preguntas Frecuentes
      </h2>
      <div className="space-y-4 max-w-3xl mx-auto" data-id="element-15">
        {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-16" />)}
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white border border-sage rounded-xl overflow-hidden shadow-sm" data-id="element-17">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-18">
        <span className="font-serif font-bold text-forest text-lg" data-id="element-19">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-forest transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-20" />
      </button>
      <AnimatePresence data-id="element-21">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-22">
            <div className="px-6 pb-4 text-gray-600" data-id="element-23">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}